import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_SECRET_KEY || "defaultSecret123";

export const encryptPayload = (data) => {
  const plaintext = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
  const iv = CryptoJS.lib.WordArray.random(16);
  const key = CryptoJS.SHA256(secretKey);
  const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const wrapper = {
    iv: iv.toString(CryptoJS.enc.Base64),
    ciphertext: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
  };

  return btoa(JSON.stringify(wrapper));
};

export const capitalize = (name) =>
  name ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : "";
